import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {Partner} from "../../../shared/interface/partner";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {PartnerService} from "../../../shared/services/partner.service";
import {EmailAddress} from "../../../shared/interface/email-address";
import {SelectionModel} from "@angular/cdk/collections";
import {take} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {Router} from "@angular/router";
import {validPesel} from "../../../shared/validator/pesel-validator";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {PhoneNumber} from "../../../shared/interface/phone-number";
import {an} from "@fullcalendar/core/internal-common";
import {PartnerOckAccount} from "../../../shared/interface/partner-ock-account";


export interface LicensedAgentDialogDate {
  partnerObject: Partner;
  addUserAccount?: boolean;
}

@Component({
  selector: 'app-ock-add',
  templateUrl: './ock-add.component.html',
  styleUrls: ['./ock-add.component.scss']
})
export class OckAddComponent implements OnInit {
  @Output() closeModification = new EventEmitter<any>();
  addUserAccount = false;
  formErrors: any = {};
  processingRequest = false;
  ockForm: FormGroup;
  partnerObject: Partner;
  selection = new SelectionModel<EmailAddress>(false, []);
  ockAccountsVerificationControl: FormControl;
  ockAccountActiveControl: FormControl;
  ockAccountLoginControl: FormControl;
  partnerControl: FormControl;
  errors: any = {};


  constructor(
    public dialogRef: MatDialogRef<OckAddComponent>,
    private fb: FormBuilder,
    private partnerService: PartnerService,
    @Inject(MAT_DIALOG_DATA) public data: LicensedAgentDialogDate,
    private snackBar: MatSnackBar,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private router: Router,
  ) {
    this.partnerObject = data.partnerObject;
    this.addUserAccount = data.addUserAccount;
    this.ockForm = this.fb.group({
      partner: this.partnerControl = fb.control('', [Validators.required]),
      firstName: fb.control('', [Validators.required]),
      lastName: fb.control('', [Validators.required]),
      pesel: fb.control('', [Validators.required, validPesel()]),
      phoneNumber: fb.control('', [Validators.required]),
      email: fb.control('', [Validators.required, Validators.email]),
      ockAccountsVerification: this.ockAccountsVerificationControl = fb.control(''),
      ockAccountActive: this.ockAccountActiveControl = fb.control(true),
      ockAccountLogin: this.ockAccountLoginControl = fb.control('', [Validators.required]),
      owner: fb.control(''),
    });
    this.partnerControl.setValue(this.partnerObject.uuid);
    if (!this.partnerObject.hasPartnerOCKAccount){
      this.ockForm.get('owner').setValue(true);
    } else {
      this.ockForm.get('owner').setValue(false);
    }
  }

  ngOnInit(): void {
  }

  emailDropList(event: CdkDragDrop<any[]>, emails: any[]): void {
    moveItemInArray(emails, event.previousIndex, event.currentIndex);
  }


  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  sendForm(): void {
    this.ockAccountLoginControl.setValue(this.ockForm.get('email').value);
    if (!this.ockForm.valid) {
      this.ockForm.markAllAsTouched();
      this.snackBar.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.partnerService.sendFormOck(this.ockForm.getRawValue())
      .subscribe({
        next: () => {
          this.snackBar.open('Pomyślnie utworzono konto', '', { duration: 2000 });
          this.dialogRef.close();
        },
        error: (error: HttpErrorResponse) => {

          console.error(error);
          const errorMessage = error.error?.error || 'Podczas tworzenia konta wystąpił błąd';
          const errorStatus = error.status ?? '500';

          this.snackBar.open(errorMessage, `${errorStatus}`, { duration: 3000 });

          if (errorStatus === 400 && error.error?.error) {
            this.errors = error.error?.error;
            if (this.errors === 'Konto z tym adresem email już istnieje') {
              this.ockForm.get('email').setErrors({ loginExists: true });
            }
            if (this.errors === 'Konto z tym numerem PESEL już istnieje') {
              this.ockForm.get('pesel').setErrors({ peselExists: true });
            }
            // Populate the form with backend error details if available

            this.formHelper.setBackendErrorState(this.ockForm, this.errors);
          }
        }
      });
  }

  phoneDropList(event: CdkDragDrop<any[]>, phones: any[]): void {
    moveItemInArray(phones, event.previousIndex, event.currentIndex);
  }

  selectPhone(phones: PhoneNumber): void{
    this.ockForm.get('phoneNumber').setValue(phones.number);
  }

  selectEmail(emailAddress: EmailAddress): void{
    this.ockForm.get('email').setValue(emailAddress.address);
  }

  isEmailInOckAccounts(email: string): boolean {
    return this.partnerObject.partnerOCKAccounts?.some(
      account => account.login === email
    ) || false;
  }

  isPhoneNumberOckAccounts(phoneNumber: string): boolean {
    return this.partnerObject.partnerOCKAccounts?.some(
      account => account.phoneNumber === phoneNumber
    ) || false;
  }

}
